// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const campaignScopeSchema = z.object({
  "min_days_idle": z.number().int().min(0).optional(),
  "tone": z.enum(["fresh", "watch", "stale", "critical"]).optional(),
  "application_ids": z.array(z.string().uuid()).optional(),
  "user_ids": z.array(z.string().uuid()).optional()
});

export const campaignSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "name": z.string(),
  "description": z.string(),
  "status": z.enum(["draft", "open", "closed", "cancelled"]),
  "opens_at": z.string().datetime({ offset: true }),
  "closes_at": z.string().datetime({ offset: true }),
  "scope": campaignScopeSchema,
  "created_at": z.string().datetime({ offset: true }),
  "created_by": z.string().uuid().nullable().optional(),
  "closed_at": z.string().datetime({ offset: true }).nullable().optional(),
  "closed_by": z.string().uuid().nullable().optional(),
  "population_basis": z.enum(["register_v1"]).optional(),
  "population_read_at": z.string().datetime({ offset: true }).nullable().optional(),
  "population_source_rows": z.number().int().min(0).nullable().optional(),
  "population_sha256": z.string().optional(),
  "total_items": z.number().int().min(0),
  "pending_items": z.number().int().min(0),
  "approved_items": z.number().int().min(0),
  "revoked_items": z.number().int().min(0)
});

export const campaignListSchema = z.object({
  "data": z.array(campaignSchema)
});

export const campaignItemSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "campaign_id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "application_id": z.string().uuid(),
  "grant_source": z.enum(["direct", "group", "both"]),
  "group_id": z.string().uuid().nullable().optional(),
  "group_name": z.string().optional(),
  "days_idle_snapshot": z.number().int(),
  "last_used_snapshot": z.string().datetime({ offset: true }).nullable().optional(),
  "user_email_snapshot": z.string(),
  "application_name_snapshot": z.string(),
  "reviewer_admin_id": z.string().uuid().nullable().optional(),
  "decision": z.enum(["pending", "approved", "revoked", "unknown", "needs_clarification", "resolved_external"]),
  "decided_at": z.string().datetime({ offset: true }).nullable().optional(),
  "decided_by": z.string().uuid().nullable().optional(),
  "decision_comment": z.string().optional(),
  "created_at": z.string().datetime({ offset: true }),
  "removal_completed_at": z.string().datetime({ offset: true }).nullable().optional(),
  "decision_history": z.array(z.object({
    "decision": z.enum(["pending", "approved", "revoked", "unknown", "needs_clarification", "resolved_external"]),
    "decided_at": z.string().datetime({ offset: true }).nullable(),
    "decided_by": z.string().uuid().nullable(),
    "comment": z.string().nullable()
  }))
});

export const campaignItemListSchema = z.object({
  "data": z.array(campaignItemSchema)
});

export const certificationCloseConflictSchema = z.object({
  "code": z.enum(["campaign-unresolved"]),
  "blockers": z.array(z.object({
    "item_id": z.string().uuid(),
    "reason": z.enum(["clarification", "group_access"])
  }))
});
